import { ImageComponent } from '@/components/Image';
import { coinConfig } from '../../helpers';
import type { IOfferCardProps } from '../../index';

type TCoinsProps = Pick<IOfferCardProps, 'coins' | 'srcImgs' | 'coinSizes'>;

export const Coins = ({ coins, srcImgs, coinSizes }: TCoinsProps) => {
  if (!coins?.length) return null;

  return coins.map((coinName) => {
    const defaultSize = coinConfig[coinName];
    const customSize = coinSizes?.[coinName];
    const { width, height } = customSize || defaultSize;
    return (
      <div className={coinName} key={coinName}>
        <ImageComponent
          alt={coinName}
          height={height}
          src={`${srcImgs}${coinName}.webp`}
          width={width}
        />
      </div>
    );
  });
};
